import gql from 'graphql-tag';

const GET_USER_SUB_DATA = gql`
  query getUserSubData(
    $subscribedToGB: Boolean!
    $subscribedToGBP: Boolean!
    $subscribedToGBX: Boolean!
  ) {
    me {
      details {
        id
        username
        email
      }
      gbSubscription: subscription(program: GLAMBAG)
        @include(if: $subscribedToGB) {
        id
        subscriptionItems {
          id
          price {
            amount
            currency
          }
        }
      }
      gbpSubscription: subscription(program: FULLSIZE)
        @include(if: $subscribedToGBP) {
        id
        subscriptionItems {
          id
          price {
            amount
            currency
          }
        }
      }
      gbxSubscription: subscription(program: GBX)
        @include(if: $subscribedToGBX) {
        id
        subscriptionItems {
          id
          price {
            amount
            currency
          }
        }
      }
    }
  }
`;

export default GET_USER_SUB_DATA;
